import { collection, getFirestore, onSnapshot, query, where } from "firebase/firestore"
import React from "react"
import { useDispatch } from "react-redux"
import { listsTask } from "../task/listTasks"
import Global from "../constants/global"

const ImportStudentData = React.memo(({ classId, year, Update }) => {
    const dispatch = useDispatch()
    React.useEffect(() => {
        // //console.log(param)
        let s
        if (classId) {

            const db = getFirestore()
            const citiesRef = collection(db, Global.STUDENTS);
            let q = query(citiesRef, where("class" + year + ".classId", "==", classId + ""));
            s = onSnapshot(q, { includeMetadataChanges: true },
                (docc) => {
                    let tklist: [] = []
                    let del = []
                    docc.docChanges().forEach((change) => {
                        const d = change.doc.data()
                        if (change.type === "removed") {
                            dispatch(listsTask.actions.remove({ type: Global.STUDENTS, data: change.doc.data() }))
                        } else {
                            tklist.push({ data: d })
                        }
                    });
                    // //console.log("AAA tklist", tklist)

                    dispatch(listsTask.actions.updateActivity({ type: Global.STUDENTS, data: tklist, isArray: true }))
                })

            Update()

        }
        return () => {
            if (s) {
                s()
            }
        }
    }, [classId, year])

    return <></>
})
export default ImportStudentData